import { CurrencyEnum } from '../../lib/types/enums/common/currency.enum'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type AffectedStaffSalary = {
  name: string
  basePrice: number
  bonusPrice: number
  currency: CurrencyEnum
}

export function getAffectedStaffPayscale(staffId: number, staffRequestId: number) {
  return restApiClient
    .url(constructApiUrl(API.staffs.payScale.url, { id: staffId, staffRequestId }))
    .get<AffectedStaffSalary>()
}

// Keyed by staff and request so that picking another staff never shows the previous pay scale
export const getAffectedStaffPayscaleQueryKey = (staffId?: number, staffRequestId?: number) => [
  'affected-staff-pay-scale',
  staffId,
  staffRequestId
]
